import React from 'react';

const TikTok = ({ className }: { className?: string }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 279.41 270.83"
			className={className}
		>
			<path
				fill="currentColor"
				d="m207.47,56.06c-15.07-9.82-25.94-25.54-29.33-43.86-.73-3.96-1.14-8.03-1.14-12.2h-48.08l-.08,192.7c-.81,21.58-18.57,38.9-40.34,38.9-6.77,0-13.14-1.69-18.75-4.64-12.87-6.77-21.67-20.26-21.67-35.77,0-22.29,18.13-40.42,40.42-40.42,4.16,0,8.15.69,11.93,1.87v-49.09c-3.91-.53-7.88-.86-11.93-.86C39.7,102.68,0,142.38,0,191.18c0,29.94,14.96,56.44,37.78,72.46,14.37,10.09,31.86,16.04,50.72,16.04,48.8,0,88.5-39.7,88.5-88.5v-97.71c18.86,13.54,41.96,21.51,66.89,21.51v-48.08c-13.43,0-25.94-3.99-36.43-10.83Z"
			/>
		</svg>
	);
};

export default TikTok;
